/** Single source of truth for this site's identity (per-repo). */
export const SITE = {
  name: 'Ariumology',
  origin: 'https://ariumology.com',
  tagline: 'Where Nature Meets Technology',
  description:
    'Expert, science-based guides for aquascaping, terrariums, paludariums, aroids, and advanced indoor plant care.',
  knowsAbout: [
    'Aquascaping',
    'Aquarium plants',
    'Aroids',
    'Terrariums',
    'Paludariums',
    'Anthurium',
    'Monstera',
    'Plant care',
  ],
  author: {
    name: 'Patrick Ivern',
    route: '/author/patrick-ivern/',
    image: '/wp-content/uploads/2025/11/about_profile.webp',
    jobTitle: 'Editor and author',
    description:
      "Patrick Ivern is the editor and author behind Ariumology's sourced guides to indoor horticulture, terrariums, paludariums, and aquascaping.",
    currentWork: 'Editorial scope and evidence standards are described in Ariumology\'s Editorial and Corrections Policy.',
    education: [] as Array<{ degree: string; focus?: string; institution: string }>,
  },
} as const

export const APP_NAME = SITE.name
export const BASE_URL =
  (import.meta as ImportMeta & { env: Record<string, string> }).env['VITE_BASE_URL'] ?? '/'
